import React, {Fragment} from 'react';
import {AutoSizer} from 'react-virtualized';

import Link from './Link';

function Pills({children, onMore}) {
  children = React.Children.toArray(children);

  return (
    <AutoSizer disableWidth>
      {({height}) => {
        const pillHeight = 30;
        const linkHeight = 27;
        const numChildren = Math.floor((height - linkHeight) / pillHeight);
        const childrenToDisplay = React.Children.toArray(children).filter((child, i) => i < numChildren);

        return (
          <Fragment>
            {childrenToDisplay}
            {childrenToDisplay.length < children.length && (
              <Link onClick={onMore}>+{(children.length - childrenToDisplay.length)} more</Link>
            )}
          </Fragment>
        );
      }}
    </AutoSizer>
  );
}

export default Pills;